import React from "react";
import MUICircularProgress from "@mui/material/CircularProgress";
import MUILinearProgress from "@mui/material/LinearProgress";
import MUIStack from "@mui/material/Stack";
import MUITypography from "@mui/material/Typography";
import MUIBox from "@mui/material/Box";

export default class Progress extends React.Component {
  /**
   * Renders a linear loading bar that fills whatever container it's
   * placed in.
   */
  render() {
    return (
      <MUIStack
        spacing={2}
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {this.props.linear ? (
          <MUIBox sx={{ width: "100%", minWidth: 300 }}>
            <MUILinearProgress
              variant={this.props.variant || "indeterminate"}
              value={
                this.props.variant === "determinate"
                  ? this.props.value
                  : undefined
              }
            />
          </MUIBox>
        ) : (
          <MUICircularProgress
            size={80}
            thickness={2}
            variant={this.props.variant || "indeterminate"}
            value={
              this.props.variant === "determinate"
                ? this.props.value
                : undefined
            }
          />
        )}

        <MUIBox sx={{ textAlign: "center" }}>
          {this.props.message && (
            <MUITypography
              variant="body1"
              color="textPrimary"
              sx={{
                display: "block",
              }}
            >
              {this.props.message}
            </MUITypography>
          )}
          {this.props.variant === "determinate" && (
            <MUITypography
              variant="body2"
              color="textSecondary"
              sx={{
                display: "block",
              }}
            >
              {Math.round(this.props.value) + "%"}
            </MUITypography>
          )}
        </MUIBox>
      </MUIStack>
    );
  }
}
